module.exports = __webpack_public_path__ + "img/logo-nav.cdade422.svg";